import { render } from "./AnnotationInstancesWidget.vue?vue&type=template&id=61bceec6&scoped=true"
import script from "./AnnotationInstancesWidget.vue?vue&type=script&lang=js"
export * from "./AnnotationInstancesWidget.vue?vue&type=script&lang=js"

import "./AnnotationInstancesWidget.vue?vue&type=style&index=0&id=61bceec6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bceec6"]])

export default __exports__